import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';

interface SettingsPageHeaderProps {
  title: string;
  description?: string;
  // Optional right-aligned slot for a page's existing action (e.g. an Edit or
  // Create button), so the header can host it instead of a separate row.
  action?: ReactNode;
}

export default function SettingsPageHeader({
  title,
  description,
  action,
}: SettingsPageHeaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 2,
        mb: 3,
      }}
    >
      <Box sx={{ maxWidth: '720px' }}>
        {/* Settings titles run smaller + heavier than the global 32px/400
            page-title variant so the title sits closer in weight to its
            subtitle and reads as a section heading (Linear-style hierarchy). */}
        <Typography variant="page-title" sx={{ fontSize: 26, fontWeight: 600 }}>
          {title}
        </Typography>
        {description ? (
          <Typography sx={{ color: 'text.secondary', fontSize: 14, mt: 0.5 }}>
            {description}
          </Typography>
        ) : null}
      </Box>
      {action ? <Box sx={{ flexShrink: 0 }}>{action}</Box> : null}
    </Box>
  );
}
